export class DatePeriod {
    dateFrom: string;
    dateTo: string;
}